import React from "react";
import { Box, Typography } from "@mui/material";
import { payerMap } from "../careGapConstants";
import { getInitials } from "../careGapUtils";

const PayerChip = ({ payer, small = false, selected = false, onClick }) => {
  const bg = payerMap[payer] || "#64748b";

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.8,
        px: small ? 0.75 : 0.9,
        py: small ? 0.45 : 0.55,
        borderRadius: "999px",
        border: "1px solid",
        borderColor: selected ? "#db2777" : "#d7dde5",
        background: selected ? "#fff1f7" : "#f8fafc",
        cursor: onClick ? "pointer" : "default",
        userSelect: "none",
      }}
    >
      <Box
        sx={{
          width: small ? 26 : 28,
          height: small ? 26 : 28,
          borderRadius: "9px",
          background: bg,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: small ? 11 : 12,
          lineHeight: 1,
        }}
      >
        {getInitials(payer)}
      </Box>

      <Typography
        sx={{
          fontSize: small ? 12 : 13,
          fontWeight: 700,
          color: "#273142",
          lineHeight: 1.1,
        }}
      >
        {payer}
      </Typography>
    </Box>
  );
};

export default PayerChip;
